import {Injectable} from '@angular/core';
import {Response } from '@angular/http';
import 'rxjs/add/operator/map';
import { AuthHttp } from '../../core/auth-http.service';

@Injectable()
export class BookingService {

    constructor(private http: AuthHttp) {}

  getSalutations() {
    return this.http.get('basic/static/salutations')
      .map((response: Response) => response.json());
  }

  getCountries() {
    return this.http.get('basic/static/countries' )
      .map((response: Response) => response.json());
  }


  sendDataToApi(data) {
    return this.http.post('order/travel/booking', data)
      .map((response: Response) => response.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/details/booking/booking.service.ts